import React from "react";

function SectionHeading({ title }) {
  return (
    <div className="section-heading">
      <div className="section-design"></div>
      <h2>{title}</h2>
      <div className="section-design"></div>
    </div>
  );
}

export default SectionHeading;
